import {ExpressionPath} from '@packages/systems/wfdl';
import {ActionCreator, createAction} from '@packages/utilities/create-action';

export const CONDITIONAL_CREATED_AT = 'CONDITIONAL_CREATED_AT';
export const CONDITIONAL_OPENED_AT = 'CONDITIONAL_OPENED_AT';
export const CONDITIONAL_CLOSED = 'CONDITIONAL_CLOSED';
export const CONDITION_GROUP_CREATED_AT = 'CONDITION_GROUP_CREATED_AT';

export const conditionalCreatedAt: ActionCreator<
  typeof CONDITIONAL_CREATED_AT,
  {
    expressionPath: ExpressionPath;
    keepSettingsOpen: boolean;
  }
> = createAction(CONDITIONAL_CREATED_AT);

export const conditionalOpenedAt: ActionCreator<
  typeof CONDITIONAL_OPENED_AT,
  {
    expressionPath: ExpressionPath;
  }
> = createAction(CONDITIONAL_OPENED_AT);

export const conditionGroupCreatedAt: ActionCreator<
  typeof CONDITION_GROUP_CREATED_AT,
  {
    expressionPath: ExpressionPath;
  }
> = createAction(CONDITION_GROUP_CREATED_AT);

export const conditionalClosed: ActionCreator<typeof CONDITIONAL_CLOSED, void> =
  createAction(CONDITIONAL_CLOSED);
